import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import { FormBuilderSwitch } from "../components/Switch";
import FontFamilySelect from "../components/FontFamilySelect";

const CheckboxGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  const handleToggleCheckbox = (event) => {
    dispatch({
      type: ACTIONS.TOGGLE_CHECKBOX,
      payload: event.target.checked,
    });
  };
  const handleToggleCheckboxContent = (event) => {
    dispatch({
      type: ACTIONS.TOGGLE_CHECKBOX_CONTENT,
      payload: event.target.checked ? "✔" : "",
    });
  };
  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };
  const handleCheckboxAlignmentChange = (event) => {
    dispatch({
      type: ACTIONS.CHECKBOX_ALIGNMENT,
      payload: event.target.value,
    });
  };

  const handleCheckboxFontWeightChange = (event) => {
    dispatch({
        type: ACTIONS.CHECKBOX_LABEL_FONT_WEIGHT_INPUT,
        payload: event.target.value,
    });
};

const handleCheckboxLabelFontFamilyChange = (event) => {
    dispatch({
        type: ACTIONS.CHECKBOX_LABEL_FONT_FAMILY_CHANGE,
        payload: event.target.value,
    });
};
  
  return (
    <div>
      <p>Add checkbox? </p>
      <FormBuilderSwitch
        checked={state.addCheckbox}
        onChange={handleToggleCheckbox}
      />
      {state.addCheckbox && (
        <>
          <div className="input-group-wrapper">
            <div>
              <h2 className="section-subheader">Font styles</h2>
              <div >
                <InputSection
                  id="checkboxInputSize"
                  title="Checkbox size"
                  value={state.checkboxInputSize}
                  actionTypeIncrement={ACTIONS.CHECKBOX_INPUT_SIZE_INCREMENT}
                  actionTypeDecrement={ACTIONS.CHECKBOX_INPUT_SIZE_DECREMENT}
                  actionTypeInput={ACTIONS.CHECKBOX_INPUT_SIZE_INPUT}
                  dispatch={dispatch}
                />
              </div>
            </div>

            <div>
              <h2 className="section-subheader">Border styles</h2>
              <div className="input-group-wrapper">
                <InputSection
                  id="checkboxBorderWidth"
                  title="Border Width"
                  value={state.checkboxBorderWidth}
                  actionTypeIncrement={ACTIONS.CHECKBOX_BORDER_WIDTH_INCREMENT}
                  actionTypeDecrement={ACTIONS.CHECKBOX_BORDER_WIDTH_DECREMENT}
                  actionTypeInput={ACTIONS.CHECKBOX_BORDER_WIDTH_INPUT}
                  dispatch={dispatch}
                />

                <InputSection
                  id="checkboxBorderRadius"
                  title="Border Radius"
                  value={state.checkboxBorderRadius}
                  actionTypeIncrement={ACTIONS.CHECKBOX_BORDER_RADIUS_INCREMENT}
                  actionTypeDecrement={ACTIONS.CHECKBOX_BORDER_RADIUS_DECREMENT}
                  actionTypeInput={ACTIONS.CHECKBOX_BORDER_RADIUS_INPUT}
                  dispatch={dispatch}
                />
              </div>
            </div>
          </div>
          <div>
            <h2 className="section-subheader">Styles when unchecked</h2>
            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Border Color</p>
                <ColorPickerInput
                  color={state.checkboxUncheckedBorderColor}
                  onChange={handleColorChange(
                    ACTIONS.CHECKBOX_UNCHECKED_BORDER_COLOR_INPUT
                  )}
                />
              </div>
              <div className="form-builder-section-div">
                <p>Background Color</p>
                <ColorPickerInput
                  color={state.checkboxUncheckedBackgroundColor}
                  onChange={handleColorChange(
                    ACTIONS.CHECKBOX_UNCHECKED_BACKGROUND_COLOR_INPUT
                  )}
                />
              </div>
            </div>
          </div>

          <div>
            <h2 className="section-subheader">Styles when checked</h2>
            <div className="form-builder-section-div-checkmark">
              <input
                type="checkbox"
                checked={state.checkedCheckboxContent === "✔"}
                onChange={handleToggleCheckboxContent}
              />
              <p>Add checkmark? </p>
            </div>
            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Checkmark Color</p>
                <ColorPickerInput
                  color={state.checkboxCheckedColor}
                  onChange={handleColorChange(
                    ACTIONS.CHECKBOX_CHECKED_COLOR_INPUT
                  )}
                />
              </div>
              <div className="form-builder-section-div">
                <p>Background Color</p>
                <ColorPickerInput
                  color={state.checkboxCheckedBackgroundColor}
                  onChange={handleColorChange(
                    ACTIONS.CHECKBOX_CHECKED_BACKGROUND_COLOR_INPUT
                  )}
                />
              </div>

              <div className="form-builder-section-div">
                <p>Border Color</p>
                <ColorPickerInput
                  color={state.checkboxCheckedBorderColor}
                  onChange={handleColorChange(
                    ACTIONS.CHECKBOX_CHECKED_BORDER_COLOR_INPUT
                  )}
                />
              </div>
            </div>
          </div>

          <div>
            <h2 className="section-subheader">Checkboxes alignment</h2>

            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Choose layout</p>
                <CustomSelect
                  labelId="chekcbox-alignment"
                  id="chekcbox-alignment"
                  selectValue={state.checkboxAlignment}
                  selectLabel="Chekcbox Alignment"
                  selectOnChange={handleCheckboxAlignmentChange}
                  menuItems={[
                    { value: "left", label: "horizontal" },
                    { value: "none", label: "stacked" },
                  ]}
                />
              </div>
            </div>
          </div>

          <h2 className="section-subheader">Label Font styles</h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Font Family</p>
                            <FontFamilySelect
                                selectedFontFamily={state.checkboxLabelFontFamily}
                                onFontFamilyChange={handleCheckboxLabelFontFamilyChange}
                            />
                        </div>

                        <InputSection
                            id="checkboxFontSize"
                            title="Font size"
                            value={state.checkboxLabelFontSize}
                            actionTypeIncrement={ACTIONS.CHECKBOX_LABEL_FONT_SIZE_INCREMENT}
                            actionTypeDecrement={ACTIONS.CHECKBOX_LABEL_FONT_SIZE_DECREMENT}
                            actionTypeInput={ACTIONS.CHECKBOX_LABEL_FONT_SIZE_INPUT}
                            dispatch={dispatch}
                        />
                        <div>
                            <p>Font Weight</p>
                            <CustomSelect
                                labelId="font-weight-checkbox"
                                id="font-weight-checkbox"
                                selectValue={state.checkboxLabelFontWeight}
                                selectLabel="Font Weight"
                                selectOnChange={handleCheckboxFontWeightChange}
                                menuItems={[
                                    { value: 100, label: "100" },
                                    { value: 200, label: "200" },
                                    { value: 300, label: "300" },
                                    { value: 400, label: "400" },
                                    { value: 500, label: "500" },
                                    { value: 600, label: "600" },
                                    { value: 700, label: "700" },
                                    { value: 800, label: "800" },
                                    { value: 900, label: "900" },
                                ]}
                            />
                        </div>
                    </div>

                    <h2 className="section-subheader">Label Color styles </h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Text Color</p>
                            <ColorPickerInput
                                color={state.inputColor}
                                onChange={handleColorChange(ACTIONS.CHECKBOX_LABEL_COLOR_INPUT)}
                            />
                        </div>

                    </div>
        </>
      )}
    </div>
  );
};

export default CheckboxGroup;
